export default __webpack_public_path__ + "static/media/party.fbb2fd7f.svg";